// extracted by mini-css-extract-plugin
export default {"container":"BreadCrumbs_container__fjSk-","link":"BreadCrumbs_link__ELaKy","active_link":"BreadCrumbs_active_link__fZ20c"};